import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { BACKEND_APIS } from "@constants"
import { autoEuropeSeasonSetsDrawerData } from "Pages/AutoEuropeTool/SeasonSets/@signals"
import { useToast } from "@hooks"

const SEASON_SETS_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/season-sets`

export default function useAutoEuropeSeasonSetsEdit(id) {
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onEdit = useCallback(() => {
		isLoading.value = true
		getSubmit(`${SEASON_SETS_API}/list`, { id })
			.then(data => {
				autoEuropeSeasonSetsDrawerData.value = {
					id: data.id,
					name: data.name,
					seasonRules: data.seasonRules ?? { dateRanges: [], followingDays: [], nextSaturday: [], finalSeason: false },
				}
				isLoading.value = false
			})
			.catch(() => {
				isLoading.value = false
				showToast.error("Error loading season set")
			})
	}, [id])

	return { onEdit, isLoading: isLoading.value }
}
